import {Box} from "@mui/material";
import {NavigationTab, PageHeader, Spacer, TabNavigation, useSelectedTab} from "common";
import {useAppSelector} from "app/hooks";
import {selectProfile} from "features/profile/profileSlice";
import I18n from "i18n-js";
import PersonIcon from "@mui/icons-material/Person";
import {Outlet} from "react-router-dom";
import useAccess from "../profile/useAccess";
import {PERMISSIONS} from "../../app/constants";
import {useEffect, useState} from "react";

export default function Home() {
  const profile = useAppSelector(selectProfile);
  const selectedTab = useSelectedTab({
    pattern: '/',
  });
  const [realSelectedTab, setRealSelectedTab] = useState<string>('');
  const access = useAccess();

  useEffect(() => {
    if (["plans", "manage-payments", "order"].indexOf(selectedTab) > -1) {
      setRealSelectedTab('');
    } else {
      setRealSelectedTab(selectedTab);
    }
  }, [selectedTab]);

  return (
    <Box>
      <PageHeader
        title={I18n.t("MyAccount.title")}
        avatar={<PersonIcon/>}
      />
      <Spacer h={2}/>
      <TabNavigation
        value={realSelectedTab || ""}
      >
        {/*{*/}
        {/*  access.hasPermissions(PERMISSIONS.MANAGE_BILLINGS_AND_PLANS)*/}
        {/*  && <NavigationTab label={I18n.t("MyAccount.pages.billingAndPlans.title")} value={""} replace/>*/}
        {/*}*/}
        <NavigationTab label={I18n.t("MyAccount.pages.myProfile.title")} value={""} replace/>
        {
          access.hasPermissions(PERMISSIONS.MANAGE_USERS)
          && <NavigationTab label={I18n.t("MyAccount.pages.staffUsers.title")} value={"staff-users"} replace/>
        }
        {
          access.hasPermissions(PERMISSIONS.MANAGE_INTEGRATIONS)
          && <NavigationTab label={I18n.t("MyAccount.pages.integrations.title")} value={"integrations"} replace/>
        }
        {
          access.hasPermissions(PERMISSIONS.MANAGE_ACTIVITY_LOG)
          && <NavigationTab label={I18n.t("MyAccount.pages.recentActivity.title")} value={"recent-activity"} replace/>
        }
      </TabNavigation>
      <Spacer h={3}/>
      <Outlet context={{
        selectedTab
      }}/>
    </Box>
  );
}
